import { CONSTANTS, NumberUtils } from '@pk/powerkioskutils';

export class ViewSupplierUpcomingOpportunity {
	public contractId: string;
	public supplierId: string;
	public supplierName: string;
	public contractNum: string;
	public endDate: Date;
	public serviceTypeId: string;
	public annualUsage: number;
	public bufferMargin: number;
	public agentId: string;
	public agentName: string;
	public numLocs: number;
	public utilityNames: string;
	public displayStatus: string;
	public dbaName: string;
	public customerId: string;
	public annualUsageConverted: number;
	public bufferMarginConverted: number;

	constructor(data?: Partial<ViewSupplierUpcomingOpportunity>) {
		Object.assign(this, data);
		const isElec = this.serviceTypeId === CONSTANTS.serviceTypes.electricity.serviceTypeId;
		const unit = isElec ? 'mwh' : 'dth';
		this.annualUsageConverted = NumberUtils.amountToUnits(this.annualUsage, unit);
		this.bufferMarginConverted = NumberUtils.rateToUnits(this.bufferMargin, unit);
	}
}
